import { render, staticRenderFns } from "./MultiStandardCategoriesSelector.vue?vue&type=template&id=7a2079f8&"
import script from "./MultiStandardCategoriesSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiStandardCategoriesSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports